import { Container } from 'react-grid-system'

import Card from '../../components/card/Card'
import Map from '../../components/map/Map'
import { HeaderLarge } from '../../components/typography/Header'
import { RESTAURANT_NAME, RESTAURANT_LOCATION } from '../../constants'
import FadeIn from 'react-fade-in'

function Home() {
  return (
    <Container style={{ maxWidth: '1000px' }}>
      <HeaderLarge>Order at {RESTAURANT_NAME}</HeaderLarge>
      <FadeIn>
        <Card
          heading="See our menu"
          text="Prepared with quality ingredients and love"
          buttonLabel="Explore"
          navigateTo="/all"
          backgroundColor="#142328"
          buttonMargin
        />
        <Card
          heading="Feeling special?"
          buttonLabel="Add a special"
          navigateTo="/specials"
          backgroundColor="#459994"
        />
      </FadeIn>
      <br />
      <HeaderLarge>Find our store</HeaderLarge>
      <Map location={RESTAURANT_LOCATION} />
    </Container>
  )
}

export default Home
